import React from 'react';
import PropTypes from 'prop-types';
import FormikCheckbox from '../formik-fields/FormikCheckbox.jsx';
import Grid from '../components/Grid.jsx';

const GridFormikCheckbox = ({ gridProps, ...props }) => {
  return (
    <Grid item {...gridProps}>
      <FormikCheckbox {...props} />
    </Grid>
  );
};

GridFormikCheckbox.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.bool,
  type: PropTypes.oneOf(['checkbox', 'radio', undefined]),
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  gridProps: PropTypes.object.isRequired
};

export default GridFormikCheckbox;
